import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

const ErrorComponent = ({ errorMessage }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', alignSelf:'flex-start',  padding: '0 20px' }}>
      <FaExclamationCircle size={20} color='#D2042D' style={{ marginRight: 10 }} />
      <span style={{ color: '#D2042D', fontSize: 13, fontFamily: 'Inter_700Bold' }}>{errorMessage}</span>
    </div>
  );
};

export default ErrorComponent;
